import filter from '@/js/util/symbols/filter'

export default {
  name: 'BaseFilterProgramCheckbox',
  inject: { filter },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    isChecked() {
      return this.filter.checkedTitles.includes(this.item.title)
    },
    isDisbaled() {
      return this.filter.checkedTitles.length === 3
    },
  },

  methods: {
    eventsToEmit(...params) {
      this.filter.$emit(...params)
    },

    createChild(createElement) {
      const elementData = {
        staticClass: this.$options.name,
        on: {
          click: () => this.eventsToEmit('create:title', this.item),
        },
        attrs: {
          type: 'checkbox',
          'aria-checked': this.isChecked.toString(),
        },
      }
      return createElement('input', elementData)
    },
  },

  render(createElement) {
    const { isChecked } = this
    const activeClass = {
      class: {
        checked: isChecked,
        disabled: !isChecked && this.isDisbaled,
      },
    }
    return createElement('label', activeClass, [this.createChild(createElement), this.$slots.default])
  },
}



// WEBPACK FOOTER //
// ./src/js/components/BaseFilterProgramCheckbox.js